/*Load more Cases*/

$(document).on('click', '.read-more', function (e) {
  e.preventDefault()
  /*global myajax*/
  var pageId = $('.cases_items').attr('id')
  var data = {
    action: 'cases',
    pageId: pageId,
    visible: $('.case_item').length,
  }
  $.ajax({
    type: 'POST',
    data: data,
    dataType: 'json',
    url: myajax.url,
  })
    .done(function (res) {
      $('.cases_items .row').append(res.html)
      if (res.show_button) {
        $('.read-more').show().text(res.button_text)
      } else {
        $('.read-more').hide()
      }
    })
    .always(function (res) {
      console.log(res) // eslint-disable-line
    })
})
